<template>

  <div v-if="(teamMembers ?? []).length > 0 || isEditing" class="etx-container Container" :class="paragraphClassList">
    <div class="etx-center Center">

      <div class="etx-flex Flex">
        <div class="etx-flex__item Flex__item mob-m:c-9 mob-l:c-12">

          <!-- <LoaderSwiper /> -->
          <div class="swiper Swiper SwiperTeam" :class="entranceClassList" :data-swiper-id="id">

            <div class="swiper-wrapper Swiper__wrapper">

              <div v-for="teamMember in teamMembers" class="swiper-slide Swiper__wrapper__slide">

                <div class="etx-card Card" :class="entranceClassList">

                  <div class="etx-card__item Card__item ph-0 pv-0">

                    <div class="etx-media Media">
                      <MediaImage :media="teamMember?.image" imageStyle="image_1_1" />
                    </div>

                  </div>

                  <div class="etx-card__item Card__item ph-0 pt-75 pb-0">

                    <div class="etx-text Text">
                      <p class="font-size-larger font-weight-bold">{{ teamMember.name }} <span class="font-uppercase">{{
                        teamMember.surname }}</span></p>
                      <p class="font-weight-bold font-color-primary">{{ teamMember?.jobTitle?.label }}</p>
                    </div>

                    <div v-if="teamMember.phone1 || teamMember.email1" class="etx-accordion-list AccordionList AccordionList__ContactInfo">
                      <div class="etx-accordion Accordion">
                        <div class="etx-accordion__header Accordion__header">

                          <div class="etx-accordion__header__button Accordion__header__button" data-accordion-clickable>
                            <i class="far fa-plus font-color-secondary"></i>
                          </div>
                        </div>
                        <div class="etx-accordion__content Accordion__content">
                          <div class="etx-item-list ItemList ">

                            <a v-if="teamMember.phone1" class="etx-item Item" :href="`tel:${ teamMember.phone1 }`" title="">
                              <div class="etx-item__icon Item__icon"><i class="fal fa-phone"></i></div>
                              <div class="etx-item__text Item__text font-weight-bold"><span>{{ formatSwissPhoneNumber(teamMember.phone1) }}</span></div>
                            </a>

                            <a v-if="teamMember.email1" class="etx-item Item" :href="`mailto:${ teamMember.email1 }`" title="">
                              <div class="etx-item__icon Item__icon"><i class="fal fa-envelope"></i></div>
                              <div class="etx-item__text Item__text font-weight-bold"><span>{{ teamMember.email1 }}</span></div>
                            </a>

                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>

              </div>

            </div>

            <div class="Swiper__controls">

              <div class="swiper-pagination Swiper__controls__pagination"></div>

            </div>

          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script lang="ts" setup>
import type { integer } from '@elastic/elasticsearch/lib/api/types';

const props = defineProps<{
  id: string | integer
  teamCategory: {
    id: string,
    label: string
  },
  teamMembers: Array<{
    name: string,
    surname: string,
    phone1: string,
    email1: string,
    categories: Array<{
      id: string,
      label: string
    }>
  }>
}>()

// Fetch the team members, with matching query key (for caching).
const category: string = props.teamCategory.id;
const queryKey = `teamMembersSlider-${category}`;
const { data: teamMembers = [] } = await useAsyncData(queryKey, async () => {
  return await useGraphqlQuery('teamMembersSlider', { 'categories': [category] }).then((v) => {
    return sortTeamMembersNull(v.data?.entityQuery?.items ?? [])
  })
})

const { options, isEditing } = defineBlokkli({
  bundle: 'team_slider_categories',
  globalOptions: ['spacingTop', 'spacingBottom', 'backgroundColor'],
})

const paragraphClassList = computed(() => {

  const classList = []

  if (options.value.spacingTop) {
    classList.push(options.value.spacingTop)
  }

  if (options.value.spacingBottom) {
    classList.push(options.value.spacingBottom)
  }

  if (options.value.backgroundColor !== 'white') {
    classList.push(options.value.backgroundColor)
  }

  return classList
})

const entranceClassList = computed(() => {
  const classList = []
  if (!isEditing) {
    classList.push('will-appear', 'move-up')
  }
  return classList
})

</script>
